import React from "react";

const AuthField = ({
  icon,
  id,
  type = "text",
  name,
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  touched,
  rightSlot,
  autoComplete,
}) => {
  return (
    <div className="auth-field-wrap">
      <div className={`auth-field ${error && touched ? "has-error" : ""}`}>
        {icon ? <span className="auth-field-icon">{icon}</span> : null}
        <input
          id={id}
          type={type}
          name={name}
          placeholder={placeholder}
          value={value || ""}
          onChange={onChange}
          onBlur={onBlur}
          autoComplete={autoComplete}
        />
        {rightSlot}
      </div>
      {error && touched ? <p className="auth-field-error">{error}</p> : null}
    </div>
  );
};

export default AuthField;
